import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {
    TRIGGER_SUMMARY_COUNTING_REQUEST,
    TRIGGER_SUMMARY_COUNTING_SUCCESS,
    TRIGGER_SUMMARY_COUNTING_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const SummaryCountingTriggerAction = (id) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_PLATFORMJK}/api/triggers/${id}/summary-counting`,
        method: 'PUT',
        headers: (headers()),
        types: [
            TRIGGER_SUMMARY_COUNTING_REQUEST,
            {
                type: TRIGGER_SUMMARY_COUNTING_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": TRIGGER_SUMMARY_COUNTING_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: TRIGGER_SUMMARY_COUNTING_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": TRIGGER_SUMMARY_COUNTING_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {SummaryCountingTriggerAction}